export default __webpack_public_path__ + "static/media/Flaticon.a53eae6b.woff";